window.POC = window.POC || {};

POC.api = {
  API_BASE: "/apps/inksoft",

  async fetchJson(url) {
    const separator = url.indexOf("?") >= 0 ? "&" : "?";
    const cacheBustedUrl = url + separator + "_ts=" + Date.now();

    const response = await fetch(cacheBustedUrl, {
      method: "GET",
      cache: "no-store",
      headers: {
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache"
      }
    });

    const rawText = await response.text();

    if (!response.ok) {
      throw new Error("HTTP " + response.status + " | " + rawText.slice(0, 300));
    }

    try {
      return JSON.parse(rawText);
    } catch (error) {
      throw new Error("Response was not valid JSON. First 300 chars: " + rawText.slice(0, 300));
    }
  },

  async getCategories() {
    const payload = await this.fetchJson(this.API_BASE + "/categories");

    if (!payload || payload.success !== true || !Array.isArray(payload.data)) {
      throw new Error("Invalid categories response");
    }

    return payload.data;
  },

  async getProductsByCategory(categoryId, options) {
    const normalizedCategoryId =
      categoryId === undefined || categoryId === null || String(categoryId).trim() === ""
        ? "ALL"
        : String(categoryId).trim();

    const skip = options && options.skip ? options.skip : 0;
    const take = options && options.take ? options.take : 48;

    const url =
      this.API_BASE +
      "/products/by-category?category=" +
      encodeURIComponent(normalizedCategoryId) +
      "&skip=" + encodeURIComponent(String(skip)) +
      "&take=" + encodeURIComponent(String(take));

    const payload = await this.fetchJson(url);

    if (!payload || payload.success !== true) {
      throw new Error("Invalid products response");
    }

    return payload;
  },

  async getAllProducts() {
    return this.getProductsByCategory("ALL", { skip: 0, take: 48 });
  },

  async getProductDetail(productId) {
    const payload = await this.fetchJson(
      this.API_BASE + "/product?id=" + encodeURIComponent(productId)
    );

    if (!payload || payload.success !== true || !payload.data) {
      throw new Error("Invalid product detail response");
    }

    return payload.data;
  }
};